import flatten from "lodash/flatten";
import isObject from "lodash/isObject";
import reduce from "lodash/reduce";

export const getKeys = (object, prefix) =>
  flatten(
    Object.keys(object).map((key) => {
      const value = object[key];
      if (isObject(value)) {
        if (prefix) {
          return getKeys(value, `${prefix}.${key}`);
        }

        return getKeys(value, key);
      }
      if (prefix) {
        return `${prefix}.${key}`;
      }

      return key;
    })
  );

export const objectContainsKeywords = (object, keyword, disallowedKeys = []) => {
  if (isObject(object)) {
    return reduce(
      Object.keys(object),
      (acc, key) => {
        if (disallowedKeys.includes(key)) return acc;
        const value = object[key];

        return acc || objectContainsKeywords(value, keyword, disallowedKeys);
      },
      false
    );
  }

  return object ? object.toString().toLowerCase().includes(keyword.toLowerCase()) : false;
};
